/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */

export const TOKEN = /{(.*?)}/i;
export const GlobalTOKEN = /{(.*?)}/g;

/**
 * this method returns true if pattern is dynamic, else returns false
 * @function isDynamicPattern
 * @param pattern - route/route path token
 * @returns isDynamicRoute Flag
 */
export const isDynamicPattern = (pattern: string) => {
  return pattern.match(TOKEN) !== null;
};

/**
 * this method trims the first and last / from the string
 * @function trimURL
 * @param str - string
 */
export const trimURL = (str: string) => {
  if (str) {
    if (str.startsWith('/')) {
      str = str.substring(1, str.length);
    }

    if (str.endsWith('/')) {
      str = str.substring(0, str.length - 1);
    }
  }
  return str;
};

/**
 * this method returns plural form of string
 * @function getPlural
 * @param str - string
 * @returns - pluralized string
 */
export const getPlural = (str: string) => {
  const lastChar = str[str.length - 1];
  const secondLastChar = str[str.length - 2];

  if (lastChar.toLowerCase() !== 'y') {
    return `${str}s`;
  }

  switch (secondLastChar.toLowerCase()) {
    case 'a':
    case 'e':
    case 'i':
    case 'o':
    case 'u':
      return `${str}s`;

    default:
      str = str.substring(0, str.length - 1);
      return `${str}ies`;
  }
};

/**
 * this method checks if the string has some numeric substring
 * @function hasNumber
 * @param str - string
 * @returns - true if numeric substring exists, else false
 */
export const hasNumber = (str: string) => {
  return /\d/.test(str);
};

/**
 * this method capitalize first letter of each word in the string
 * @function capitalizeFirstLetter
 * @param string - string
 * @returns - string with each word capitalize
 */
export const capitalizeFirstLetter = (string: string) => {
  let arr = string.split(' ');
  arr = arr.map((element) => element.charAt(0).toUpperCase() + element.slice(1));
  return arr.join(' ');
};

/**
 * this method checks for the portal query param present in the given url
 * @param urlSearchParam - URLSearchParams object
 * @returns - true if portal query param exists in the url
 */
export const isPortalParamExists = (urlSearchParam: URLSearchParams) => {
  const urlParam = urlSearchParam.toString();
  return urlParam.includes('portal=');
};

/**
 * This method converts the given input string to kebab case
 * e.g. ProductLandingPage -> product-landing-page
 * @param inputString input string to covert
 * @return - converted string in kebab case
 */
export const convertToKebabCase = (inputString: string) => {
  const patterForNonCamelCase = /(?=[A-Z][a-z])/g;
  const outputString = inputString.replace(patterForNonCamelCase, '-').toLowerCase();
  if (outputString.startsWith('-')) {
    return outputString.substring(1);
  }
  return outputString;
};
